module.exports = __webpack_public_path__ + "media/bootstrap-icons/alt-07bed87b.svg";